module.exports = "<p>\n  submitted-app works!\n</p>\n"